import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
export var agentArticles = /*#__PURE__*/css("margin-top:28px;margin-bottom:12px;padding:0 15px;", media('>=desktop'), "{padding:unset;}");
export var title = /*#__PURE__*/css(typography.desktopHeadingL, " margin-bottom:16px;");